import React from 'react';
import { Route } from 'react-router-dom';
import { Placeholder } from 'semantic-ui-react';

import './WorkspaceContent.css';

const WorkspaceContent = (props) => {
  const { tabs } = props;
  return (
    <div className="ds__WorkspaceContent">
      {tabs.map((tab) => (
        <Route key={tab.url} path={tab.url} children={({ match }) => (
          <div
            className="ds__WorkspaceContent__content"
            style={{display: match === null ? 'none' : 'block'}}
            children={React.createElement(tab.content)}
          />
        )} />
      ))}
    </div>
  );
};

export default WorkspaceContent;

WorkspaceContent.Placeholder = (props) => (
  <div className="ds__WorkspaceContent">
    <Placeholder>
      <Placeholder.Header image>
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Header>
      <Placeholder.Paragraph>
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Paragraph>
    </Placeholder>
  </div>
);
